/* ============================================================================
 *  Centralised wrapper for all doctor‑onboarding endpoints
 * ========================================================================== */
import axiosInstance from './axiosInstance'; // ✅ adjust if your path differs
import publicAxios from './publicAxios'; // For public endpoints

const BASE = '/doctors/onboarding/';

// helpers ----------------------------------------------------------
const pickFirst = (arr) => (Array.isArray(arr) && arr.length ? arr[0] : null);

// public API -------------------------------------------------------
export const onboardingApi = {
  // core flow ------------------------------------------------------
  fetch: () => axiosInstance.get(BASE).then((r) => pickFirst(r.data)),
  availableOptions: () =>
    axiosInstance.get(`${BASE}available_options/`).then((r) => r.data),
  submitStep: (id, body) =>
    axiosInstance.post(`${BASE}${id}/submit_step/`, body).then((r) => r.data),
  saveDraft: (id, body) =>
    axiosInstance.post(`${BASE}${id}/save_draft/`, body).then((r) => r.data),
  resetStep: (id, step) =>
    axiosInstance
      .post(`${BASE}${id}/reset_step/`, { step })
      .then((r) => r.data),

  // document verification -----------------------------------------
  uploadDocument: (id, formData) =>
    axiosInstance
      .post(`${BASE}${id}/upload_document/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data),

  verificationStatus: (id) =>
    axiosInstance.get(`${BASE}${id}/verification_status/`).then((r) => r.data),
};

/* ============================================================================
 *  Doctor Dashboard API endpoints
 * ========================================================================== */
export const doctorDashboardApi = {
  // Dashboard statistics
  getStats: () => axiosInstance.get('/appointments/dashboard/stats/'),

  // Patient and revenue trends
  getTrends: (months = 6) =>
    axiosInstance.get(`/appointments/dashboard/trends/?months=${months}`),

  // Consultation type distribution
  getConsultationDistribution: () =>
    axiosInstance.get('/appointments/dashboard/consultation-distribution/'),
};

/* ============================================================================
 *  Public Doctor Profile API endpoints - MUST use publicAxios for unauthenticated access
 * ========================================================================== */
export const publicDoctorApi = {
  // Get public doctor profile (SEO optimized) - PUBLIC endpoint
  getPublicProfile: (doctorId) => publicAxios.get(`/doctors/${doctorId}/profile/`),
  
  // Get doctor availability - PUBLIC endpoint
  getAvailability: (doctorId, date) => publicAxios.get(`/doctors/${doctorId}/availability/?date=${date}`),
  
  // Book appointment - This requires authentication, but initial check is public
  // Note: Actual booking should use authenticated axiosInstance
  bookAppointment: (doctorId, appointmentData) => axiosInstance.post(`/doctors/${doctorId}/book/`, appointmentData),
};
